module.exports = __webpack_public_path__ + "img/img-test-1.ca301128.png";